import { useReducer } from "react";
import { GlobalContext } from "./GlobalContext";

const win = window;
const currentURL = window.location.href;
const hostname = window.location.hostname
const lang = document.documentElement.lang;
if (window.location.href.includes("localhost")) {
  const lang = "en"; //'ar'
  !!!win["lang"] && (win["lang"] = lang);
  !!!win["checkoutUrl"] && (win["checkoutUrl"] = "http://ssta004:8080/wps/portal/web/personal/e-commerce/checkout");
  !!!win["productUrl"] && (win["productUrl"] = "http://ssta004:8080/web/en/devices/phones-and-accessories");
  !!!win["errorPageURL"] && (win["errorPageURL"] = 'http://ssta004:8080/wps/portal/web/personal/store/error');
  !!!win['timeoutPageURL'] && (win['timeoutPageURL'] = 'http://ssta004:8080/wps/portal/web/personal/store/timeouterror');
} else {
  const lang = document.documentElement.lang;
  let checkoutEndPoint = '/wps/portal/web/personal/e-commerce/checkout'
  let homepageEndPoint = `/web/${lang === 'ar' ? 'ar' : 'en'}/devices/phones-and-accessories`

  if (!hostname.includes('mobily.com.sa')) {
    if (currentURL.includes('gtm')) {
      checkoutEndPoint = '/wps/portal/web/personal/e-commerce/checkout-gtm'
      homepageEndPoint = `/wps/portal/web/personal/e-commerce/phones-and-accessories-gtm`
    }
    if (currentURL.includes('subsidy')) {
      checkoutEndPoint = '/wps/portal/web/personal/e-commerce/checkout-subsidy'
      homepageEndPoint = `/wps/portal/web/personal/e-commerce/phones-and-accessories-subsidy`
    }
  }

  !!!win["lang"] && (win["lang"] = lang);
  !!!win["checkoutUrl"] && (win["checkoutUrl"] = window.location.origin + checkoutEndPoint);
  !!!win["productUrl"] && (win["productUrl"] = window.location.origin + homepageEndPoint);
  !!!win["errorPageURL"] && (win["errorPageURL"] = window.location.origin + '/wps/portal/web/personal/store/error');
  !!!win['timeoutPageURL'] && (win['timeoutPageURL'] = window.location.origin + '/wps/portal/web/personal/store/timeouterror')
}

const rtl = win["lang"] === "ar";
const dir = win["lang"] === null || win["lang"] === "en" ? "ltr" : "rtl";
 let homepageEndPoint = `/web/${lang === 'ar' ? 'ar' : 'en'}/devices/phones-and-accessories`
const homePageLink = window.location.origin.includes("localhost")
  ? "http://ssta004:8080/web/en/devices/phones-and-accessories"
  : window.location.origin + homepageEndPoint;

const initialState = {
  rtl: rtl,
  dir: dir,
  xCoId: "",
  loading: false,
  outOfStock: false,
  homePageUrl: homePageLink,
  productData: {},
  currentPage: 'cartPage',
  selectedAcPlan: {},
  msisdn: "",
  OTPData: {},
  otpValue: "",
  scData: {},
  appleCareApplied: false,
  customerInfo: {},
  isSubsidyApplied: false,
  isInstallmentApplied: false,
  newStack: "N",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOADER":
      return {
        ...state,
        loading: action.payload.loading,
      };

    case "XCOID":
      return {
        ...state,
        xCoId: action.payload.xCoId,
      };
    case "STOCK_STATUS":
      return {
        ...state,
        outOfStock: action.payload.outOfStock,
      };

    case 'CURRENT_PAGE':
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    case 'PRODUCT_DATA':
      return {
        ...state,
        productData: action.payload.productData,
      };
    case 'SELECTED_AC_PLAN':
      return {
        ...state,
        selectedAcPlan: action.payload.selectedAcPlan,
      };
    case 'SELECTED_PLAN_NAME':
      return {
        ...state,
        planName: action.payload.planName,
      };
    case 'DEVICE_MOBILENUMBER':
      return {
        ...state,
        msisdn: action.payload.msisdn,
      };
    case 'INITATE_OTP_DATA':
      return {
        ...state,
        OTPData: action.payload.OTPData,
      };
    case 'CAPTURE_OTP_VALUE':
      return {
        ...state,
        otpValue: action.payload.otpValue,
      };
    case 'SC_RESPONSE':
      return {
        ...state,
        scData: action.payload.scData,
      };
    case 'APPLECARE_APPLIED':
      return {
        ...state,
        appleCareApplied: action.payload.appleCareApplied,
      };
    case 'CUSTOMER_INFO':
      return {
        ...state,
        customerInfo: action.payload.customerInfo,
      };
    case 'IS_SUBSIDY_APPLIED':
      return {
        ...state,
        isSubsidyApplied: action.payload.isSubsidyApplied,
      };
    case 'IS_INSTALLMENT_APPLIED':
      return {
        ...state,
        isInstallmentApplied: action.payload.isInstallmentApplied,
      };
    case 'NEW_STACK':
      return {
        ...state,
        newStack: action.payload.newStack,
      };

    default:
      return state;
  }
};

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {props.children}
    </GlobalContext.Provider>
  );
};
